/**
 * Storm initializer in the no inline script mode
 *
 * WARNING: This JS may not be served by the same service as the one which serves
 * HTML/CSS which this JS depends on. E.g. this JS may be served by a BabyStorm
 * while the HTML/CSS may be served by Storm. Take care when updating this JS or any
 * related HTML/CSS.
 * See https://wiki.yext.to/index.php/Postmortem:IN-1085_Capacity_Limit_Exceeded_Modal_in_Customer_Portal#Root_causes
 * for context.
 *
 * @author Manit Hirani (mhirani@yext.com)
 */

goog.module('yext.storm.StormInitializer');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
/** @suppress {extraRequire} */
goog.require('yext.plugins.characterCounter');
/** @suppress {extraRequire} */
goog.require('yext.plugins.contextualHelp');
/** @suppress {extraRequire} */
goog.require('yext.plugins.selectbox');
const navigation = goog.require('yext.storm.navigation');
const tablefade = goog.require('yext.ui.tablefade');
const notify = goog.require('yext.notify');
const localization = goog.require('yext.localization');
const helpform = goog.require('yext.helpform');
const LockedAccount = goog.require('yext.subscriptions.LockedAccount');
const PixelTracking = goog.require('yext.storm.PixelTracking');
const {logError} = goog.require('yext.ui.lib.errors');

/**
* @constructor
*/
const StormInitializer = function() {
  this.initData = {};

  var $stormInit = $('.js-storm-init');
  if ($stormInit.length) {
    if ($stormInit.hasClass('no-nonce')) {
      this.initData = JSON.parse($stormInit.html());
    } else {
      this.initData = $stormInit.data();
    }
  }

  this.init();
};

/**
 * Common initialization for all pages in storm
 */
StormInitializer.prototype.init = function() {
  $('select:not(.add-location)').selectbox();

  // Initialize our new selectbox, and avoid triggering the old
  // and handle positioning our dropdown
  $('.gumi').gumi(yext.gumiConfig);

  // Initialize custom character counters
  $('.js-character-counter').characterCounter();

  // Initialize contextual help and bootstrap tooltip
  $('.info-icon, .custom-info-icon, .js-bind-contextual-help').contextualHelp({fade: true});

  // intialize tooltips
  $('.js-tooltip').tooltip();

  $(window).resize(function() {
    $('.ui-dialog-content').dialog('option', 'position', ['center', 'center']);
  });

  navigation.init();

  tablefade.init();

  this.initGoogleAnalytics();
  PixelTracking.init();

  if (this.initData['haspendo'] === 'true') {
    this.initPendo();
  }

  // Powerlistings
  window['powerListingSingular'] = this.initData['powerlistingsingular'];
  window['powerListingPlural'] = this.initData['powerlistingplural'];

  if (typeof window.attachEvent == 'undefined') {
    window['attachEvent'] = window['addEventListener'];
  }

  if (this.initData['isembedded'] === 'true') {
    window['stormIsEmbedded'] = true;
  }

  try {
    this.initLocalization();
  } catch (err) {
    logError(err);
  }

  // Map from country code to display name for use in JS
  if (this.initData['countriesjson']) {
    storm['countries'] = this.initData['countriesjson'];
  }

  if (this.initData['helpform']) {
    helpform.init();
  }

  this.initDam();

  $(document).ready(function() {
    new LockedAccount($('.js-subscriptions-locked-account-dialog'));

    notify.init();
    notify.showUrlMessage();
  });
};

StormInitializer.prototype.initGoogleAnalytics = function() {
  var _gaq = _gaq || [];
  _gaq.push(['_setAccount', 'UA-32988846-1']);
  _gaq.push(['_setDomainName', 'yext.com']);
  var pathname = window.location.pathname;
  var path = pathname.replace(/[\d]+\//g, '');
  _gaq.push(['_trackPageview', path]);


  (function() {
    var ga = document.createElement('script'); ga.type = 'text/javascript'; ga.async = true;
    ga.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'www.google-analytics.com/ga.js';
    var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ga, s);
  })();
};

StormInitializer.prototype.initPendo = function() {
  var self = this;
  (function(apiKey) {
    let promise = new Promise(function(resolve, reject) {
      let scriptElement;
      (function(p, e, n, d, o) {
        var v; var w; var x; var y; var z; o=p[d]=p[d]||{}; o._q=[];
        v=['initialize', 'identify', 'updateOptions', 'pageLoad']; for (w=0, x=v.length; w<x; ++w) {
          (function(m) {
            o[m]=o[m]||function() {
              o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments, 0)));
            };
          })(v[w]);
        }
        y=e.createElement(n); y.async=!0; y.src='https://cdn.pendo.io/agent/static/'+apiKey+'/pendo.js';
        scriptElement=y;
        z=e.getElementsByTagName(n)[0]; z.parentNode.insertBefore(y, z);
      })(window, document, 'script', 'pendo');

      scriptElement.onload = function() {
        resolve();
      };
    });

    promise.then(() => {
      var pendoVisitorJson = self.initData['pendovisitorjson'];
      if (pendoVisitorJson) {
        pendoVisitorJson['events'] = {
          ready: () => pendo.loadGuides(),
        };
        pendoVisitorJson['inlineStyleNonce'] = window['cspStyleNonce'];
        pendo.initialize(pendoVisitorJson);
      }
    });
  })('a613a114-8c2f-4b6b-6856-64c485608b1d');
};

StormInitializer.prototype.initDam = function() {
  window['WIDGETS_ID'] = this.initData['widgetsid'];

  window['getAddressFormForCountry'] = this.initData['countryaddressurl'];
  window['getCountryLanguages'] = this.initData['countrylangsurl'];
  window['chinaJsonUrl'] = this.initData['chinajsonurl'];
  window['customAddressInputNamesAndValues'] = this.initData['customaddressdetails'];
};

StormInitializer.prototype.initLocalization = function() {
  var supplementConfigKey = 'supplementjsonconfig';
  if (supplementConfigKey in this.initData) {
    // single quotes need to be replaced to make this parseable
    Cldr.load(JSON.parse(this.initData[supplementConfigKey].replace(/'/g, '"')));
  }

  var curLangConfigKey = 'currentlangjsonconfig';
  if (curLangConfigKey in this.initData) {
    Cldr.load(this.initData[curLangConfigKey]);
  }

  localization.init();
};

if ($('body').data('noinline')) {
  try {
    new StormInitializer();
  } catch (err) {
    logError(err);
  }
}

exports = StormInitializer;
